import * as CitiesByState from "./CitiesByState/index.js";
import * as CityByCountry from "./CityByCountry/index.js";
import * as CountiesByState from "./CountiesByState/index.js";
import * as Fund from "./Fund/index.js";
import * as FundCompany from "./FundCompany/index.js";
import * as GlobalTypeAhead from "./GlobalTypeAhead/index.js";
import * as PostalCodeGlobal from "./PostalCodeGlobal/index.js";
import * as Professional from "./Professional/index.js";
import * as RetailBrand from "./RetailBrand/index.js";
import * as StatesByCountry from "./StatesByCountry/index.js";
import * as Tenant from "./Tenant/index.js";
import * as TenantCompany from "./TenantCompany/index.js";
/** CoStar.Api.Lookup.SubmarketMatchType */
export var SubmarketMatchType;
(function (SubmarketMatchType) {
    SubmarketMatchType[SubmarketMatchType["None"] = 0] = "None";
    SubmarketMatchType[SubmarketMatchType["Submarket"] = 5] = "Submarket";
    SubmarketMatchType[SubmarketMatchType["SubmarketCluster"] = 34] = "SubmarketCluster";
})(SubmarketMatchType || (SubmarketMatchType = {}));
/** CoStar.Api.Lookup.SubmarketPropertyType */
export var SubmarketPropertyType;
(function (SubmarketPropertyType) {
    SubmarketPropertyType[SubmarketPropertyType["None"] = 0] = "None";
    SubmarketPropertyType[SubmarketPropertyType["Hospitality"] = 1] = "Hospitality";
    SubmarketPropertyType[SubmarketPropertyType["Industrial"] = 2] = "Industrial";
    SubmarketPropertyType[SubmarketPropertyType["Office"] = 5] = "Office";
    SubmarketPropertyType[SubmarketPropertyType["Retail"] = 6] = "Retail";
    SubmarketPropertyType[SubmarketPropertyType["Multifamily"] = 11] = "Multifamily";
})(SubmarketPropertyType || (SubmarketPropertyType = {}));
import { MatchType } from "../../../CoStar/Api/ExternalApi/ViewModels/MultipleTypeAhead/index.js";
/** CoStar.Api.Lookup.MatchType */
export { MatchType };
/** CoStar.Api.Lookup.OfficeType */
export var OfficeType;
(function (OfficeType) {
    OfficeType[OfficeType["None"] = 0] = "None";
    OfficeType[OfficeType["MainHeadquarter"] = 1] = "MainHeadquarter";
    OfficeType[OfficeType["DivisionalHeadquarter"] = 2] = "DivisionalHeadquarter";
    OfficeType[OfficeType["CorporateOffice"] = 3] = "CorporateOffice";
    OfficeType[OfficeType["Franchise"] = 4] = "Franchise";
    OfficeType[OfficeType["SingleLocation"] = 5] = "SingleLocation";
    OfficeType[OfficeType["RetailStoreBranch"] = 6] = "RetailStoreBranch";
    OfficeType[OfficeType["Warehouse"] = 7] = "Warehouse";
    OfficeType[OfficeType["OnSitePropertyManagementNoOccupancy"] = 8] = "OnSitePropertyManagementNoOccupancy";
})(OfficeType || (OfficeType = {}));
import { SearchType } from "../../../CoStar/Api/ExternalApi/ViewModels/MultipleTypeAhead/index.js";
/** CoStar.Api.Lookup.SearchType */
export { SearchType };
import { PropertyType } from "../../../CoStar/Api/ExternalApi/ViewModels/MultipleTypeAhead/index.js";
/** CoStar.Api.Lookup.PropertyType */
export { PropertyType };
export { CitiesByState, CityByCountry, CountiesByState, Fund, FundCompany, GlobalTypeAhead, PostalCodeGlobal, Professional, RetailBrand, StatesByCountry, Tenant, TenantCompany };
